// import React from "react";
// import { Grid, IconButton, MenuItem, Select } from "@mui/material";
// import AddBoxIcon from "@mui/icons-material/AddBox";
// import DigitalClock from "../DigitalClock/DigitalClock";
// import { DoctorconsoleGrid, StyledSelect } from "../StyledComponents";
// const DoctorconsoleHeader = ({
//   patient,
//   selectedContext,
//   setSelectedContext,
//   setSelectedContextDisplay,
//   care_context_list,
//   setAddCareContextModalOpen,
// }) => {
//   console.log("Patient Details", patient);
//   return (
//     <DoctorconsoleGrid
//       container
//       sx={{
//         maxHeight: "400px",
//         overflowY: "auto",
//         padding: "10px",
//       }}
//       className="fixedDiv"
//     >
//       <DoctorconsoleGrid
//         container
//         sx={{
//           borderBottom: "3px solid #bae0dd",
//           padding: "10px 0",
//         }}
//         spacing={2}
//       >
//         <DoctorconsoleGrid
//           item
//           container
//           xs={12}
//           sm={12}
//           md={4}
//           spacing={2}
//           sx={{
//             alignItems: "center",
//           }}
//         >
//           <DoctorconsoleGrid item xs={12} sm={6}>
//             <h2 className="console-heading">Patient Name: {patient?.name}</h2>
//           </DoctorconsoleGrid>
//           <DoctorconsoleGrid item xs={6} sm={2.5}>
//             <h2 className="console-heading">Age: {patient?.age}</h2>
//           </DoctorconsoleGrid>
//           <DoctorconsoleGrid item xs={6} sm={3.5}>
//             <h2 className="console-heading">Gender: {patient?.gender}</h2>
//           </DoctorconsoleGrid>
//         </DoctorconsoleGrid>
//         <DoctorconsoleGrid
//           item
//           container
//           xs={12}
//           sm={8}
//           md={6}
//           spacing={1}
//           sx={{
//             alignItems: "center",
//           }}
//         >
//           <DoctorconsoleGrid
//             item
//             xs={3}
//             sm={3}
//             md={2}
//             sx={{
//               textAlign: { xs: "left", sm: "left", md: "center" },
//             }}
//           >
//             <h2 className="console-heading">Visit Purpose:</h2>
//           </DoctorconsoleGrid>

//           <DoctorconsoleGrid item xs={8} sm={7} md={9}>
//             <StyledSelect
//               fullWidth
//               name="carecontext_ref_id"
//               value={selectedContext}
//               onChange={(event) => {
//                 const selectedValue = event.target.value;
//                 setSelectedContext(selectedValue);

//                 // Find the selected item in care_context_list
//                 const selectedContextItem = care_context_list.find(
//                   (item) => item.care_context_reference === selectedValue
//                 );

//                 // Set the display value to setSelectedContextDisplay
//                 if (selectedContextItem) {
//                   setSelectedContextDisplay(selectedContextItem.display);
//                 }
//               }}
//               sx={{
//                 marginRight: "8px",
//                 color: "black",
//                 minWidth: "120px",
//               }}
//             >
//               {care_context_list &&
//                 care_context_list.map((item, index) => (
//                   <MenuItem key={index} value={item.care_context_reference}>
//                     {item.description} {item.care_context_reference}
//                   </MenuItem>
//                 ))}
//             </StyledSelect>
//           </DoctorconsoleGrid>
//           <DoctorconsoleGrid item xs={1} sm={2} md={1}>
//             <IconButton
//               onClick={() => setAddCareContextModalOpen(true)}
//               title="Add Visit Purpose"
//             >
//               <AddBoxIcon />
//             </IconButton>
//           </DoctorconsoleGrid>
//         </DoctorconsoleGrid>
//         <DoctorconsoleGrid
//           item
//           xs={12}
//           sm={4}
//           md={2}
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <DigitalClock />
//         </DoctorconsoleGrid>
//       </DoctorconsoleGrid>
//     </DoctorconsoleGrid>
//   );
// };

// export default DoctorconsoleHeader;

// import React from "react";
// import { Grid, IconButton, MenuItem, Select } from "@mui/material";
// import AddBoxIcon from "@mui/icons-material/AddBox";
// import DigitalClock from "../DigitalClock/DigitalClock";
// import { DoctorconsoleGrid, StyledSelect } from "../StyledComponents";
// const DoctorconsoleHeader = ({
//   patient,
//   selectedContext,
//   setSelectedContext,
//   setSelectedContextDisplay,
//   care_context_list,
//   setAddCareContextModalOpen,
// }) => {
//   console.log("Patient Details", patient);
//   return (
//     <DoctorconsoleGrid
//       container
//       sx={{
//         maxHeight: "400px",
//         overflowY: "auto",
//         padding: "10px",
//       }}
//       className="fixedDiv"
//     >
//       <DoctorconsoleGrid
//         container
//         sx={{
//           borderBottom: "3px solid #bae0dd",
//           padding: "10px 0",
//         }}
//         spacing={2}
//       >
//         <DoctorconsoleGrid
//           item
//           container
//           xs={12}
//           sm={12}
//           md={4}
//           spacing={2}
//           sx={{
//             alignItems: "center",
//           }}
//         >
//           <DoctorconsoleGrid item xs={12} sm={6}>
//             <h2 className="console-heading">Patient Name: {patient?.name}</h2>
//           </DoctorconsoleGrid>
//           <DoctorconsoleGrid item xs={6} sm={2.5}>
//             <h2 className="console-heading">Age: {patient?.age}</h2>
//           </DoctorconsoleGrid>
//           <DoctorconsoleGrid item xs={6} sm={3.5}>
//             <h2 className="console-heading">Gender: {patient?.gender}</h2>
//           </DoctorconsoleGrid>
//         </DoctorconsoleGrid>
//         <DoctorconsoleGrid
//           item
//           container
//           xs={12}
//           sm={8}
//           md={6}
//           spacing={1}
//           sx={{
//             alignItems: "center",
//           }}
//         >
//           <DoctorconsoleGrid
//             item
//             xs={3}
//             sm={3}
//             md={2}
//             sx={{
//               textAlign: { xs: "left", sm: "left", md: "center" },
//             }}
//           >
//             <h2 className="console-heading">Visit Purpose:</h2>
//           </DoctorconsoleGrid>

//           <DoctorconsoleGrid item xs={8} sm={7} md={9}>
//             <StyledSelect
//               fullWidth
//               name="carecontext_ref_id"
//               value={selectedContext}
//               onChange={(event) => {
//                 const selectedValue = event.target.value;
//                 setSelectedContext(selectedValue);

//                 // Find the selected item in care_context_list
//                 const selectedContextItem = care_context_list.find(
//                   (item) => item.care_context_reference === selectedValue
//                 );

//                 // Set the display value to setSelectedContextDisplay
//                 if (selectedContextItem) {
//                   setSelectedContextDisplay(selectedContextItem.display);
//                 }
//               }}
//               sx={{
//                 marginRight: "8px",
//                 color: "black",
//                 minWidth: "120px",
//               }}
//             >
//               {care_context_list &&
//                 care_context_list.map((item, index) => (
//                   <MenuItem key={index} value={item.care_context_reference}>
//                     {item.description} {item.care_context_reference}
//                   </MenuItem>
//                 ))}
//             </StyledSelect>
//           </DoctorconsoleGrid>
//           <DoctorconsoleGrid item xs={1} sm={2} md={1}>
//             <IconButton
//               onClick={() => setAddCareContextModalOpen(true)}
//               title="Add Visit Purpose"
//             >
//               <AddBoxIcon />
//             </IconButton>
//           </DoctorconsoleGrid>
//         </DoctorconsoleGrid>
//         <DoctorconsoleGrid
//           item
//           xs={12}
//           sm={4}
//           md={2}
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <DigitalClock />
//         </DoctorconsoleGrid>
//       </DoctorconsoleGrid>
//     </DoctorconsoleGrid>
//   );
// };

// export default DoctorconsoleHeader;
//============================================================================
// import React from "react";
// import {
//   Card,
//   CardContent,
//   Avatar,
//   Typography,
//   Box,
//   MenuItem,
//   Select,
//   IconButton,
//   Button,
//   Grid,
// } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import PauseIcon from "@mui/icons-material/Pause";
// import ReplayIcon from "@mui/icons-material/Replay";
// import DigitalClock from "../DigitalClock/DigitalClock";

// const DoctorconsoleHeader = () => {
//   const [visit, setVisit] = React.useState("Visit_[12/08/25, 11:00]rfphmb-13");

//   return (
//     <Card
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "space-between",
//         p: 1,
//         borderRadius: "20px",
//         bgcolor: "#12a712ff",
//         boxShadow: "0px 1px 3px rgba(0,0,0,0.1)",
//       }}
//     >
//       {/* Left Section */}
//       <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//         <Avatar sx={{ bgcolor: "#e0e0e0", width: 48, height: 48 }} />
//         <Box>
//           <Typography variant="subtitle1" fontWeight="bold" color="primary">
//             Ankit Raj
//           </Typography>
//           <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
//             <Typography variant="body2">
//               <b>Age:</b> 26
//             </Typography>
//             <Typography variant="body2">
//               <b>Gender:</b> Male
//             </Typography>
//             <Typography variant="body2">
//               <b>Visit Purpose:</b>
//             </Typography>
//             <Select
//               size="small"
//               value={visit}
//               onChange={(e) => setVisit(e.target.value)}
//               sx={{ minWidth: 220, fontSize: "0.85rem" }}
//             >
//               <MenuItem value="Visit_[12/08/25, 11:00]rfphmb-13">
//                 Visit_[12/08/25, 11:00]rfphmb-13
//               </MenuItem>
//               <MenuItem value="Visit_[14/08/25, 09:30]xyz-01">
//                 Visit_[14/08/25, 09:30]xyz-01
//               </MenuItem>
//             </Select>
//           </Box>
//         </Box>
//       </Box>

//       {/* Right Section */}
//       <Grid>
//         <Grid
//           item
//           xs={12}
//           sm={4}
//           md={2}
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <DigitalClock />
//         </Grid>
//       </Grid>
//     </Card>
//   );
// };

// export default DoctorconsoleHeader;
//==================================================

import React from "react";
import {
  Card,
  Avatar,
  Typography,
  Box,
  MenuItem,
  Select,
  IconButton,
  Grid,
  Divider,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DigitalClock from "../DigitalClock/DigitalClock";
import { StyledSelect, StyledSelectForHeader } from "../StyledComponents";
import { styles } from "./DoctorconsoleHeader.styles";
import Icon from "./Icons";

// const DoctorconsoleHeader = ({
//   patient,
//   selectedContext,
//   setSelectedContext,
//   setSelectedContextDisplay,
//   care_context_list,
//   setAddCareContextModalOpen,
// }) => {
//   return (
//     <Card
//       sx={{
//         p:1,
//         borderRadius: "20px",
//         bgcolor: "#F0F8F0",
//         boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.25)",
//         justifyContent: "center",
//       }}
//     >
//       <Grid container spacing={1} alignItems="center" justifyContent="center">
//         {/* Avatar + Patient Name */}
//         <Grid item xs={12} sm={6} md={2.7} display="flex" alignItems="center">
//           <Avatar sx={{ bgcolor: "#e0e0e0", width: 48, height: 48, mr: 1 }} />
//           <Typography
//             variant="subtitle1"
//             fontWeight={700}
//             color="#121959"
//             sx={{
//               fontFamily: "Inter",
//               fontSize: "32px",
//               fontStyle: "bold",
//               lineHeight: "100%",
//               letterSpacing: "0%",
//             }}
//           >
//             {patient?.name}
//             {/* Ankit Raj */}
//           </Typography>
//         </Grid>

//         {/* Age + Gender */}
//         <Grid item xs={12} sm={6} md={2}>
//           <Box display="flex" gap={2} flexWrap="wrap">
//             <Typography
//               sx={{
//                 color: "#000",
//                 fontFamily: "Inter",
//                 fontSize: "20px",
//                 fontStyle: "normal",
//                 fontWeight: 500,
//                 lineHeight: "20px",
//               }}
//             >
//               <b>Age:</b> {patient?.age}
//             </Typography>
//             <Typography
//               sx={{
//                 color: "#000",
//                 fontFamily: "Inter",
//                 fontSize: "20px",
//                 fontStyle: "normal",
//                 fontWeight: 500,
//                 lineHeight: "20px",
//               }}
//             >
//               <b>Gender:</b> {patient?.gender}
//             </Typography>
//           </Box>
//         </Grid>

//         {/* Visit Purpose + Select + Add */}
//         <Grid item xs={12} sm={12} md={5.2}>
//           <Box
//             display="flex"
//             flexDirection="row"
//             alignItems="center"
//             gap={1}
//             flexWrap="wrap"
//           >
//             <Typography
//               sx={{
//                 color: "#000",
//                 fontFamily: "Inter",
//                 fontSize: "20px",
//                 fontStyle: "normal",
//                 fontWeight: 500,
//                 lineHeight: "20px",
//               }}
//             >
//               <b>Visit Purpose:</b>
//             </Typography>
//             <StyledSelect
//               fullWidth
//               name="carecontext_ref_id"
//               value={selectedContext}
//               onChange={(event) => {
//                 const selectedValue = event.target.value;
//                 setSelectedContext(selectedValue);

//                 // Find the selected item in care_context_list
//                 const selectedContextItem = care_context_list.find(
//                   (item) => item.care_context_reference === selectedValue
//                 );

//                 // Set the display value to setSelectedContextDisplay
//                 if (selectedContextItem) {
//                   setSelectedContextDisplay(selectedContextItem.display);
//                 }
//               }}
//               sx={{
//                 color: "black",
//                 minWidth: "120px",
//                 maxWidth: "500px",
//               }}
//             >
//               {care_context_list &&
//                 care_context_list.map((item, index) => (
//                   <MenuItem key={index} value={item.care_context_reference}>
//                     {item.description} {item.care_context_reference}
//                   </MenuItem>
//                 ))}
//             </StyledSelect>

//             <IconButton
//               onClick={() => setAddCareContextModalOpen(true)}
//               title="Add Visit Purpose"
//             >
//               <img
//                 src="/assets/images/newIcons/addition.svg"
//                 alt="Add"
//                 style={{ width: 24, height: 24 }}
//               />
//             </IconButton>
//           </Box>
//         </Grid>
//         <Divider
//           orientation="vertical"
//           flexItem
//           sx={{
//             marginLeft: 1,
//             marginRight: 2,
//             color: "rgba(0, 0, 0, 0.25)",
//             width: "1px",
//           }}
//         />
//         {/* Digital Clock */}
//         <Grid
//           item
//           xs={12}
//           sm={12}
//           md={1}
//           display="flex"
//           // justifyContent={{ xs: "flex-start", md: "flex-end" }}
//           justifyContent={"flex-start"}
//         >
//           {/* Vertical divider */}

//           <DigitalClock />
//         </Grid>
//       </Grid>
//     </Card>
//   );
// };

const DoctorconsoleHeader = ({
  patient,
  selectedContext,
  setSelectedContext,
  setSelectedContextDisplay,
  care_context_list,
  setAddCareContextModalOpen,
}) => {
  return (
    <Card sx={styles.card}>
      <Grid container spacing={1} alignItems="center" justifyContent="center">
        {/* Avatar + Patient Name */}
        <Grid item xs={12} sm={6} md={2.8} display="flex" alignItems="center">
          <Avatar sx={styles.avatar} />
          <Typography sx={styles.patientName}>{patient?.name}</Typography>
        </Grid>

        {/* Age + Gender */}
        <Grid item xs={12} sm={6} md={2}>
          <Box display="flex" gap={0.5} flexWrap="wrap" justifyContent="center">
            <Typography sx={styles.ageGenderText}>
              <b>Age:</b> {patient?.age}
            </Typography>
            <Typography sx={styles.ageGenderText}>
              <b>Gender:</b> {patient?.gender}
            </Typography>
          </Box>
        </Grid>

        <Grid
          item
          container
          xs={12}
          sm={8}
          md={5.5}
          spacing={1}
          sx={{
            alignItems: "center",
          }}
        >
          {/* Label */}
          <Grid
            item
            xs={3}
            sm={3}
            md={2.5}
            sx={{
              textAlign: { xs: "left", sm: "left", md: "center" },
            }}
          >
            <Typography sx={styles.visitPurposeLabel}>
              <b>Visit Purpose:</b>
            </Typography>
          </Grid>

          {/* Select */}
          <Grid item xs={8} sm={7} md={8.5}>
            <StyledSelectForHeader
              fullWidth
              name="carecontext_ref_id"
              value={selectedContext}
              onChange={(event) => {
                const selectedValue = event.target.value;
                setSelectedContext(selectedValue);

                const selectedContextItem = care_context_list.find(
                  (item) => item.care_context_reference === selectedValue
                );

                if (selectedContextItem) {
                  setSelectedContextDisplay(selectedContextItem.display);
                }
              }}
              sx={styles.select}
              MenuProps={{
                disablePortal: true,
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                PaperProps: {
                  style: {
                    maxHeight: 200,
                    width: "auto",
                  },
                },
              }}
            >
              {care_context_list &&
                care_context_list.map((item, index) => (
                  <MenuItem
                    key={index}
                    value={item.care_context_reference}
                    sx={{ fontSize: "14px" }}
                  >
                    {item.description} {item.care_context_reference}
                  </MenuItem>
                ))}
            </StyledSelectForHeader>
          </Grid>

          {/* Add Icon */}
          <Grid item xs={1} sm={2} md={1}>
            <IconButton
              onClick={() => setAddCareContextModalOpen(true)}
              title="Add Visit Purpose"
            >
              {/* <img
                src="/assets/images/newIcons/addition.svg"
                alt="Add"
                style={styles.addIcon}
              /> */}
              <Icon name="addition" size={20} />
            </IconButton>
          </Grid>
        </Grid>

        {/* Divider */}
        <Divider orientation="vertical" flexItem sx={styles.divider} />

        {/* Digital Clock */}
        <Grid
          item
          xs={12}
          sm={3.6}
          md={1.5}
          display="flex"
          justifyContent="flex-start"
        >
          <DigitalClock />
        </Grid>
      </Grid>
    </Card>
  );
};

export default DoctorconsoleHeader;
